// extracted by mini-css-extract-plugin
module.exports = {"avatar":"dialog-presence_avatar_W7mYl"};